export const usDateFormate = (str) => {
  const temp = str.split("-");

  return `${temp[1]}/${temp[2]}/${temp[0]}`;
};
